<template>
  <div class="document-list-view">
    <div class="document-list-desktop">
      <simple-table
        classes="basic sortable selectable celled padded document-list-table"
        :items="rows"
        :loading="loading"
        :headers="headers"
        @selected="onSelect"
      >
        <template v-slot:row="{ item }">
          <td class="document-list-table__number">{{ item.number }}</td>
          <td class="document-list-table__customer-cell">
            <div class="document-list-table__customer text-body-medium-strong">{{ item.customerName }}</div>
            <div
              v-if="hasReference(item.reference)"
              class="document-list-table__reference"
            >{{ item.reference }}</div>
          </td>
          <td class="document-list-table__date">{{ item.issuedDate }}</td>
          <td class="document-list-table__date">{{ item.secondaryDate }}</td>
          <td class="document-list-table__status">
            <document-status-pill :status="item.status" />
          </td>
          <td class="document-list-table__amount text-body-medium-strong">{{ item.amountText }}</td>
        </template>
      </simple-table>
    </div>

    <div class="document-list-mobile">
      <document-list-card
        v-for="row in rows"
        :key="'document-list-mobile-' + row.id"
        :number="row.number"
        :customer-name="row.customerName"
        :reference="row.reference"
        :issued-date="row.issuedDate"
        :secondary-date="row.secondaryDate"
        :secondary-date-label="secondaryDateLabel"
        :amount-text="row.amountText"
        :status="row.status"
        @select="onSelect(row)"
      />
      <div
        v-if="rows.length === 0 && !loading"
        class="document-list-mobile__empty"
      >Nothing to display</div>
    </div>
  </div>
</template>

<script>
import SimpleTable from './SimpleTable.vue'
import DocumentListCard from './DocumentListCard.vue'
import DocumentStatusPill from './DocumentStatusPill.vue'

/**
 * Shared quotes/invoices list chrome — desktop `document-list-table` + mobile cards.
 * Pass normalized `rows` so Quotes, Invoices, and Customer Edit stay visually aligned.
 *
 * Row shape: { id, number, customerName, reference, issuedDate, secondaryDate, status, amountText, source? }
 */
export default {
  name: 'DocumentListView',
  components: {
    SimpleTable,
    DocumentListCard,
    DocumentStatusPill
  },
  props: {
    rows: { type: Array, default: function () { return [] } },
    loading: { type: Boolean, default: false },
    headers: {
      type: Array,
      default: function () {
        return ['Number', 'Customer', 'Issued', 'Expiry', 'Status', 'Amount']
      }
    },
    secondaryDateLabel: { type: String, default: 'Expiry' }
  },
  methods: {
    hasReference: function (reference) {
      const text = String(reference || '').trim()
      return text !== '' && text !== '-'
    },
    onSelect: function (row) {
      this.$emit('select', row && row.source != null ? row.source : row)
    }
  }
}
</script>
